import { useCallback } from 'react';
import { DataTable } from '../../../../../components/UI/MDC/DataTable/DataTable';
import ADGroupMapping from './ADGroupMapping';
import {
	DeactivateAppADGroup,
	DeactivateAppCloudGroup,
	DeactivateAppEUGroup,
} from '../../../_api';
import { AD_TYPES } from 'pages/ApplicationMaintenance/_constants';
import AppADGroupRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/AppADGroupRequest';
import AppCloudGroupRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/AppCloudGroupRequest';
import AppEUGroupRequest from 'Classes/ResponseModels/ApplicationManagement/AppEUGroupRequest';
import ApiErrors from '../../../components/NewApplication/ApiErrors';

const ADGroupsDisplay = ({
	adGroupxRefs,
	appID,
	readOnly,
	app,
	type = AD_TYPES.ON_PREM,
	currentUser,
	requirementNumber,
	reload,
	apiErrors,
	setApiErrors,
}) => {
	const handleDelete = useCallback(
		(_, __, row) => {
			let request;
			let xref;

			switch (type) {
				case AD_TYPES.CLOUD:
					xref = adGroupxRefs.find(
						el => el.ID.toString() === row.Key
					);
					request = new AppCloudGroupRequest(app, currentUser, xref);
					request.RequirementNumber = requirementNumber;

					DeactivateAppCloudGroup(request)
						.then(response => {
							setApiErrors(response.App.Errors);
						})
						.then(() => reload());
					break;
				case AD_TYPES.EU:
					xref = adGroupxRefs.find(
						el => el.ID.toString() === row.Key
					);
					request = new AppEUGroupRequest(app, currentUser, xref);
					request.RequirementNumber = requirementNumber;

					DeactivateAppEUGroup(request)
						.then(response => {
							setApiErrors(response.App.Errors);
						})
						.then(() => reload());
					break;
				case AD_TYPES.ON_PREM:
					xref = adGroupxRefs.find(
						el => el.ID.toString() === row.Key
					);
					request = new AppADGroupRequest(app, currentUser, xref);
					request.RequirementNumber = requirementNumber;

					DeactivateAppADGroup(request)
						.then(resp => {
							setApiErrors(resp.App.Errors);
						})
						.then(() => reload());
					break;
				default:
					break;
			}
		},
		[
			type,
			adGroupxRefs,
			requirementNumber,
			app,
			currentUser,
			reload,
			setApiErrors,
		]
	);

	const actions = [{ Type: 'remove', onChangedHandler: handleDelete }];

	const headersOnPrem = [
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{
			Value: 'SAM Account Name',
			props: { sort: null, onSortChange: null },
		},
		{ Value: 'Object SID', props: { sort: null, onSortChange: null } },
		{ Value: 'SQL Statement', props: { sort: null, onSortChange: null } },
	];

	const headersCloud = [
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{ Value: 'Display Name', props: { sort: null, onSortChange: null } },
		{ Value: 'SQL Statement', props: { sort: null, onSortChange: null } },
	];

	const headersEU = [
		{ Value: 'ID', props: { sort: null, onSortChange: null } },
		{
			Value: 'Group Name',
			props: { sort: null, onSortChange: null },
		},
		{
			Value: 'SQL Statement',
			props: { sort: null, onSortChange: null },
		},
	];

	const rows = adGroupxRefs
		.filter(xref =>
			type !== AD_TYPES.ON_PREM ? true : xref.ADGroup !== null
		)
		.map(xref => {
			const arrActionCells = [
				{
					BindTo: 0,
					Text: 'Deactivate',
				},
			];
			const objValidation = {
				Key: 'true',
				Value: null,
				memberToValidateKey: null,
			};
			let row;

			switch (type) {
				case AD_TYPES.CLOUD:
					row = {
						ActionCells: arrActionCells,
						Cells: {
							ID: {
								Value: xref.ID,
								Validation: objValidation,
							},
							'Display Name': {
								Value: xref.GroupDisplayName,
								Validation: objValidation,
							},
							'SQL Statement': {
								Value: xref.SQLStatement,
								Validation: objValidation,
							},
						},
						Key: xref.ID.toString(),
					};
					break;
				case AD_TYPES.EU:
					row = {
						ActionCells: arrActionCells,
						Cells: {
							ID: {
								Value: xref.ID,
								Validation: objValidation,
							},
							'Group Name': {
								Value: xref.GroupName,
								Validation: objValidation,
							},
							'SQL Statement': {
								Value: xref.SQLStatement,
								Validation: objValidation,
							},
						},
						Key: xref.ID.toString(),
					};
					break;
				case AD_TYPES.ON_PREM:
					row = {
						ActionCells: arrActionCells,
						Cells: {
							ID: {
								Value: xref.ADGroup.ID,
								Validation: objValidation,
							},
							'SAM Account Name': {
								Value: xref.ADGroup.SamAccountName,
								Validation: objValidation,
							},
							'Object SID': {
								Value: xref.ADGroup.ObjectSID,
								Validation: objValidation,
								props: {
									extendtext: 20,
								},
							},
							'SQL Statement': {
								Value: xref.SQLStatement,
								Validation: objValidation,
							},
						},
						Key: xref.ID.toString(),
					};
					break;
				default:
					break;
			}

			return row;
		});

	return (
		<div>
			<ApiErrors errors={apiErrors} />
			<DataTable
				actions={actions}
				rows={rows}
				headers={
					type === AD_TYPES.CLOUD
						? headersCloud
						: type === AD_TYPES.EU
						? headersEU
						: headersOnPrem
				}
			/>
			<ADGroupMapping
				adXREF={adGroupxRefs}
				apiErrors={apiErrors}
				appID={appID}
				readOnly={readOnly}
				app={app}
				type={type}
				currentUser={currentUser}
				requirementNumber={requirementNumber}
				reload={reload}
				setApiErrors={setApiErrors}
			/>
		</div>
	);
};

export default ADGroupsDisplay;
